module.exports = __webpack_public_path__ + "img/Peppe.a586692a.png";